import { render, staticRenderFns } from "./BsiContinuousFilingMessages.vue?vue&type=template&id=7c9823aa&scoped=true&"
import script from "./BsiContinuousFilingMessages.vue?vue&type=script&lang=js&"
export * from "./BsiContinuousFilingMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9823aa",
  null
  
)

export default component.exports